export enum ProcessingTimeScope {
  PROCESSING_TODAY = 'processing_today',
  PROCESSING_FUTURE = 'processing_future',
  COMPLETED_TODAY = 'completed_today',
  RESET = 'reset'
}
